import { render, staticRenderFns } from "./FormOrderPhase.vue?vue&type=template&id=53867b1e&"
import script from "./FormOrderPhase.vue?vue&type=script&lang=js&"
export * from "./FormOrderPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports